export const initRemoveFeaturedTag = () => {
  if (document.querySelector('.single-post')) {
    document.querySelectorAll('.tag-item').forEach((tag) => {
      if (tag.textContent.trim() === 'Featured') {
        tag.remove();
      }
    });
  }
};
